/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Unit_TestsInputs */

const en_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit tests`)
};

const ar_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختبارات الوحدة`)
};

const bn_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইউনিট টেস্ট`)
};

const de_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit-Tests`)
};

const es_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruebas unitarias`)
};

const fr_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tests unitaires`)
};

const pt_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testes unitários`)
};

const zh_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单元测试`)
};

const tr_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birim testleri`)
};

const ru_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модульные тесты`)
};

const pl_svchip_unit_tests = /** @type {(inputs: Svchip_Unit_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testy jednostkowe`)
};

/**
* | output |
* | --- |
* | "Unit tests" |
*
* @param {Svchip_Unit_TestsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_unit_tests = /** @type {((inputs?: Svchip_Unit_TestsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Unit_TestsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_unit_tests(inputs)
	if (locale === "bn") return bn_svchip_unit_tests(inputs)
	if (locale === "de") return de_svchip_unit_tests(inputs)
	if (locale === "es") return es_svchip_unit_tests(inputs)
	if (locale === "fr") return fr_svchip_unit_tests(inputs)
	if (locale === "pt") return pt_svchip_unit_tests(inputs)
	if (locale === "zh") return zh_svchip_unit_tests(inputs)
	if (locale === "tr") return tr_svchip_unit_tests(inputs)
	if (locale === "ru") return ru_svchip_unit_tests(inputs)
	if (locale === "pl") return pl_svchip_unit_tests(inputs)
	return en_svchip_unit_tests(inputs)
});